import React from 'react';
import style from './OpenCloseButton.module.scss';

const OpenCloseButton = ({ clicked, onClick, buttonStyle }) => (
  <button
    name="button"
    className={buttonStyle !== 'close' ? style.button : style.closeButton}
    onClick={onClick}
  >
    {buttonStyle !== 'close' ? (
      <div className={!clicked ? style.cross : style.crossClicked} />
    ) : (
      <div className={style.crossClicked} />
    )}
  </button>
);

export default OpenCloseButton;



// WEBPACK FOOTER //
// ./src/components/ui/OpenCloseButton.js